import React from 'react';
import PropTypes from 'prop-types';
import { Badge } from '@els/els-react--badge';
import { ButtonWithIcon } from '@els/els-react--button';
import { byValue, occurrence } from '@Containers/ResultsFilters/ResultsFiltersConstants';
import SortingDropdown from '@Containers/ResultsFilters/ResultsFiltersComponents/SortingDropdown';
import './TopPanel.scss';

function TopPanel({
  selectedCount,
  onClickClearSelected,
  disableClearSelected,
  onDescending,
  disableDescending,
  onAscending,
  disableAscending,
  sortingType,
  onOccurrence,
  onByValue,
}) {
  return (
    <div className="new-author-checkboxes-dialog__top-panel">
      <div className="new-author-checkboxes-dialog__selection-controls">
        <span className="new-author-checkboxes-dialog__selected-count">
          <Badge type="subtle" content={`${selectedCount}`} /> selected
        </span>
        <ButtonWithIcon
          data-e2e="clear-selected"
          type="link"
          size="small"
          sprite="Close"
          linkIconSize="xs"
          iconRight
          disabled={disableClearSelected}
          onClick={onClickClearSelected}
          className="e2e-clear-selected">
          Clear selected
        </ButtonWithIcon>
      </div>
      <div className="new-author-checkboxes-dialog__sorting-controls">
        <SortingDropdown
          sortingType={sortingType}
          onOccurrence={onOccurrence}
          onByValue={onByValue}
          onClickClearSelected={onClickClearSelected}
          className="new-author-checkboxes-dialog__sorting-dropdown"
        />
        <ButtonWithIcon
          data-e2e="sort-descending"
          type="link"
          size="small"
          sprite="ArrowDown"
          linkIconSize="xs"
          disabled={disableDescending}
          onClick={onDescending}
          className="e2e-desc">
          <span className="u-els-hide-visually">Descending</span>
        </ButtonWithIcon>
        <ButtonWithIcon
          data-e2e="sort-ascending"
          type="link"
          size="small"
          sprite="ArrowUp"
          linkIconSize="xs"
          disabled={disableAscending}
          onClick={onAscending}
          className="e2e-asc">
          <span className="u-els-hide-visually">Ascending</span>
        </ButtonWithIcon>
      </div>
    </div>
  );
}

TopPanel.propTypes = {
  onClickClearSelected: PropTypes.func.isRequired,
  disableClearSelected: PropTypes.bool,
  onAscending: PropTypes.func.isRequired,
  onDescending: PropTypes.func.isRequired,
  disableAscending: PropTypes.bool,
  disableDescending: PropTypes.bool,
  onByValue: PropTypes.func.isRequired,
  onOccurrence: PropTypes.func.isRequired,
  sortingType: PropTypes.oneOf([occurrence, byValue]).isRequired,
  selectedCount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default TopPanel;
